import styled from "styled-components";

export const Container = styled.div<{ withMarginBottom: boolean }>`
  bottom: -1px;
  position: sticky;
  z-index: 1;
  ${({ withMarginBottom }) =>
    withMarginBottom && `margin-bottom: var(--spacer-s);`}
`;

interface WrapProps {
  isSticky: boolean;
}
const stickyStyle = `
  box-shadow: 2px 2px 6px 0 rgb(0 0 0 / 35%);
  margin-left: -3%;
  width: 105%;
`;
export const Wrap = styled.section<WrapProps>`
  transition: box-shadow 150ms ease-in-out, margin 150ms ease-in-out,
    width 150ms ease-in-out;
  width: 100%;
  ${(props) => props.isSticky && stickyStyle}
`;
